import { defineComponent as t, openBlock as r, createElementBlock as o, mergeProps as s, renderSlot as m } from "vue";
import "./ghl-ui.es222.js";
const n = t({
  name: "UITextSmNormal",
  inheritAttrs: !1
}), a = t({
  ...n,
  setup(l) {
    return (e, c) => (r(), o("div", s(e.$attrs, { class: "hl-text-sm-medium" }), [
      m(e.$slots, "default")
    ], 16));
  }
}), d = a;
export {
  d as default
};
